(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-recently-viewed-products"]) return;
  try {
    
  (() => {
    const maxStoredProducts = 20;
    const root = window.Shopify?.routes?.root || '/';

    const normalizeHandles = (handles) => {
      if (!Array.isArray(handles)) return [];

      return handles
        .filter((handle) => typeof handle === 'string' && handle.length)
        .filter((handle, index, self) => self.indexOf(handle) === index);
    };

    const readHandles = (storageKey) => {
      try {
        return normalizeHandles(JSON.parse(window.localStorage.getItem(storageKey)));
      } catch (error) {
        return [];
      }
    };

    const writeHandles = (storageKey, handles) => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(handles.slice(0, maxStoredProducts)));
      } catch (error) {
        // Storage can be unavailable in private browsing or restricted environments.
      }
    };

    const recordCurrentProduct = (storageKey, currentProductHandle) => {
      if (!currentProductHandle) return;

      const handles = readHandles(storageKey).filter((handle) => handle !== currentProductHandle);
      handles.unshift(currentProductHandle);
      writeHandles(storageKey, handles);
    };

    const buildProductCardUrl = (handle) => `${root}products/${encodeURIComponent(handle)}?view=recently-viewed-card`;

    const fetchProductCard = (section, handle, index) => (
      fetch(buildProductCardUrl(handle))
        .then((response) => (response.ok ? response.text() : ''))
        .then((html) => {
          const trimmedHtml = html.trim();
          if (!trimmedHtml) return '';

          return `
            <div data-slide-index="${index}" id="carousel-${section.id}-slide-${index}" class="carousel-slide">
              ${trimmedHtml}
            </div>
          `;
        })
        .catch(() => '')
    );

    const initializeSection = (section) => {
      if (section.dataset.recentlyViewedInitialized === 'true') return;
      section.dataset.recentlyViewedInitialized = 'true';

      const list = section.querySelector('[data-recently-viewed-products-list]');
      const currentProductHandle = section.dataset.currentProductHandle;
      const storageKey = section.dataset.storageKey;
      const limit = Number(section.dataset.limit) || 4;

      const handles = readHandles(storageKey)
        .filter((handle) => handle !== currentProductHandle)
        .slice(0, limit);

      if (!handles.length || !list) {
        recordCurrentProduct(storageKey, currentProductHandle);
        return;
      }

      Promise.all(handles.map((handle, index) => fetchProductCard(section, handle, index))).then((cards) => {
        const productCards = cards.filter((card) => card);
        if (!productCards.length) {
          recordCurrentProduct(storageKey, currentProductHandle);
          return;
        }

        list.innerHTML = productCards.join('');
        section.hidden = false;

        if (typeof initializeExistingColumnCarousels === 'function') {
          initializeExistingColumnCarousels();
        }

        recordCurrentProduct(storageKey, currentProductHandle);
      });
    };

    document.querySelectorAll('.recently-viewed-products').forEach(initializeSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-related-product"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations[data-url]');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          initializeExistingColumnCarousels();
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations[data-url]');

  if (productRecommendationsSection) {
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendationsSection);
  }

  } catch(e) { console.error(e); }
})();
})();
